import React from 'react';
import { connect } from 'react-redux';
import { Dispatch, bindActionCreators } from 'redux';
import { useTranslation } from 'react-i18next';
import { setContactModalOn } from '../../../actions/modal';
import { VZephyrsConfig } from '../../../utils/interface';

interface addZephyrModalProps {
  setZephyrModalOpen: Function;
  vZephyrsConfig: VZephyrsConfig;
  setContactModalOn: Function;
}

const VZLimitReachedModal = ({
  setZephyrModalOpen,
  vZephyrsConfig,
  setContactModalOn,
}: addZephyrModalProps) => {
  const { t: translate } = useTranslation();

  const vZephyrsTitle = () => {
    let title = `${translate('maxReachPrefix')} ${
      vZephyrsConfig.max
    } ${translate('totalPostfix')}`;
    return (
      <>
        <p className="text-mustard">{title}</p>
        <p>{translate('limitReachedSubtitle')}</p>
      </>
    );
  };

  return (
    <div className="modal-container zephyr-modal-container d-flex flex-column">
      <button
        className="button close close-modal"
        onClick={() => {
          setZephyrModalOpen(false);
        }}
        type="button"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="13"
          height="13"
          viewBox="0 0 24 24"
          fill="#000"
        >
          <path d="M23 20.168l-8.185-8.187 8.185-8.174-2.832-2.807-8.182 8.179-8.176-8.179-2.81 2.81 8.186 8.196-8.186 8.184 2.81 2.81 8.203-8.192 8.18 8.192z" />
        </svg>
      </button>
      <h4>{translate('headerText')}</h4>
      <div className="form-content-container pb-2">
        <div className="row pb-5">{vZephyrsTitle()}</div>

        <div className="row d-flex justify-content-between">
          <button
            type="button"
            className="button tertiary"
            onClick={() => setZephyrModalOpen(false)}
          >
            {translate('secondaryCta')}
          </button>

          <button
            className="button primary"
            onClick={() => {
              setZephyrModalOpen(false);
              setContactModalOn();
            }}
          >
            {translate('contactUsCtaTxt')}
          </button>
        </div>
      </div>
    </div>
  );
};

const mapDispatchToProps = (dispatch: Dispatch) =>
  bindActionCreators(
    {
      setContactModalOn,
    },
    dispatch,
  );

export default connect(null, mapDispatchToProps)(VZLimitReachedModal);
